<template>
    <v-form
        v-model="valid"
        @submit.prevent="$emit('submit')"
    >
        <v-text-field
            autofocus
            v-model="name"
            label="Nama lengkap"
            :rules="rules.name"
        ></v-text-field>

        <v-text-field
            v-model="username"
            label="Username"
            :rules="rules.username"
            ref="username"
            @change="checkUsernameAvailability"
            :loading="$store.get('loader/loading', 'usernameLookup')"
            :success-messages="usernameSuccessMessage"
            :error-messages="usernameErrorMessage"
        ></v-text-field>

        <v-text-field
            v-model="email"
            label="E-mail"
            :rules="rules.email"
            ref="email"
            @change="checkEmailAvailability"
            :loading="$store.get('loader/loading', 'emailLookup')"
            :success-messages="emailSuccessMessage"
            :error-messages="emailErrorMessage"
        ></v-text-field>

        <v-autocomplete
            v-model="university"
            label="Tipe Ujian"
            :items="universities"
            :rules="rules.university"
        ></v-autocomplete>

        <v-text-field
            v-model="contact"
            label="ID Line / WA"
            :rules="rules.contact"
        ></v-text-field>

        <v-text-field
            v-model="password"
            label="Password"
            type="password"
            :rules="rules.password"
        ></v-text-field>

        <v-text-field
            v-model="passwordConfirmation"
            label="Ulangi password"
            type="password"
            :rules="rules.passwordConfirmation"
        ></v-text-field>

        <v-btn
            type="submit"
            block
            large
            :disabled="!valid"
            :loading="$store.get('loader/loading', 'signup')"
            color="primary"
        >
            Daftar
        </v-btn>
    </v-form>
</template>

<script>
import { sync } from 'vuex-pathify'
import rules from '@/validations/SignupTryoutData'

export default {
    props: ['submit'],

    data() {
        return {
            valid: null,
            rules,
            universities: rules.universityLists,
            usernameSuccessMessage: '',
            usernameErrorMessage: '',
            emailSuccessMessage: '',
            emailErrorMessage: '',
        }
    },

    computed: sync('home/*'),

    methods: {
        checkUsernameAvailability() {
            this.usernameSuccessMessage = ''
            this.usernameErrorMessage = ''

            if (this.$refs.username.valid) {
                this.$api
                    .get('auth/isUsernameAvailable', {
                        params: {
                            username: this.username,
                        },
                        loader: 'usernameLookup',
                    })
                    .then((response) => {
                        if (response.data.available) {
                            this.usernameSuccessMessage = 'Username tersedia'
                        } else {
                            this.usernameErrorMessage =
                                'Username sudah dipakai, gunakan username lain'
                        }
                    })
            }
        },

        checkEmailAvailability() {
            this.emailSuccessMessage = ''
            this.emailErrorMessage = ''

            if (this.$refs.email.valid) {
                this.$api
                    .get('auth/isEmailAvailable', {
                        params: {
                            email: this.email,
                        },
                        loader: 'emailLookup',
                    })
                    .then((response) => {
                        if (response.data.available) {
                            this.emailSuccessMessage = 'E-mail tersedia'
                        } else {
                            this.emailErrorMessage =
                                'E-mail sudah dipakai, gunakan e-mail lain'
                        }
                    })
            }
        },
    },
}
</script>
